import axios, { AxiosResponse } from "axios"
import { checkResponseStatus } from "./Utils"
import { SearchResult } from 'cs.node.utils/SearchUtils'

export const searchInCloudStore = async (searchTerm: string, controller: AbortController) => {
    try {
        const response:AxiosResponse<{status: "ok" | "ko", results: SearchResult[]},any> = await axios.get(`api/search?term=${encodeURIComponent(searchTerm)}`, 
        { 
            signal: controller.signal 
        })
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}